var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcIconSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    focusable: "false"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.14 5.429a.482.482 0 0 1 0-.68l1.2-1.2a.482.482 0 0 1 .68 0l1.948 1.944a.481.481 0 0 0 .678 0L9.986.14a.483.483 0 0 1 .68-.002l1.193 1.185a.48.48 0 0 1 .002.678l-6.475 6.49c-.187.188-.555.34-.82.34h-.559c-.264 0-.632-.153-.818-.34L.139 5.43z"
  })));
}
export default __webpack_public_path__ + "static/media/ic-icon-success.4e68d87f.svg";
export { SvgIcIconSuccess as ReactComponent };